import React, { Component } from "react";
import axios from "axios";

class Server extends React.Component {
  constructor(props) {
    super(props);
    this.type = 8;
    this.system = 0;
    this.firebaseConfig = [
      {
        apiKey: "-",
        authDomain: "-",
        projectId: "-",
        storageBucket: "-",
        messagingSenderId: "-",
        appId: "-"
      },
      {
        apiKey: "-",
        authDomain: "-",
        projectId: "-",
        storageBucket: "-",
        messagingSenderId: "-",
        appId: "-"
      },
      {
        apiKey: "AIzaSyDOvtmYfxDRAstJFWG97HQHU75TAXs-qpA",
        authDomain: "sarvcart.firebaseapp.com",
        projectId: "sarvcart",
        storageBucket: "sarvcart.appspot.com",
        messagingSenderId: "678023038033",
        appId: "1:678023038033:web:0322acde1d91b371c42470"
      },
      {
        apiKey: "-",
        authDomain: "-",
        projectId: "-",
        storageBucket: "-",
        messagingSenderId: "-",
        appId: "-"
      },
      {
        apiKey: "-",
        authDomain: "-",
        projectId: "-",
        storageBucket: "-",
        messagingSenderId: "-",
        appId: "-"
      },
      {
        apiKey: "-",
        authDomain: "-",
        projectId: "-",
        storageBucket: "-",
        messagingSenderId: "-",
        appId: "-"
      },
      {
        apiKey: "AIzaSyDOvtmYfxDRAstJFWG97HQHU75TAXs-qpA",
        authDomain: "sarvcart.firebaseapp.com",
        projectId: "sarvcart",
        storageBucket: "sarvcart.appspot.com",
        messagingSenderId: "678023038033",
        appId: "1:678023038033:web:9436558a150ec173c42470"
      },
      {
        apiKey: "-",
        authDomain: "-",
        projectId: "-",
        storageBucket: "-",
        messagingSenderId: "-",
        appId: "-"
      },
      {
        apiKey: "AIzaSyDOvtmYfxDRAstJFWG97HQHU75TAXs-qpA",
        authDomain: "sarvcart.firebaseapp.com",
        projectId: "sarvcart",
        storageBucket: "sarvcart.appspot.com",
        messagingSenderId: "678023038033",
        appId: "1:678023038033:web:0322acde1d91b371c42470"
      },
      {
        apiKey: "AIzaSyDOvtmYfxDRAstJFWG97HQHU75TAXs-qpA",
        authDomain: "sarvcart.firebaseapp.com",
        projectId: "sarvcart",
        storageBucket: "sarvcart.appspot.com",
        messagingSenderId: "678023038033",
        appId: "1:678023038033:web:0322acde1d91b371c42470"
      }

    ]

    this.serverUrl = [
      "http://localhost:3000/", /* 0 */
      "https://api.samin360.ir/", /* 1 */
      "https://marketapi.ansar724.com/", /* 2 */
      "https://demoapi.sarvapps.ir/", /* 3 */
      "https://api.ostoorehcart.com/", /* 4 */
      "https://ansar724.iran.liara.run/", /* 5 */
      "https://ansarcrm.iran.liara.run/", /* 6 */
      "https://nikan.iran.liara.run/", /* 7 */
      'https://ansar.iran.liara.run/', /* 8 */
      "https://mehr724.iran.liara.run/" /* 9 */
    ];

    this.parentApiAddress = [
      null, /* 0 */
      null, /* 1 */
      null, /* 2 */
      null, /* 3 */
      null, /* 4 */
      null, /* 5 */
      null, /* 6 */
      null, /* 7 */
      null, /* 8 */
      "https://ansar.iran.liara.run/" /* 9 */
    ];

    this.systemCode = [
      {
        name: "قرض الحسنه انصارالهدی",
        id: "620641793b2d00005a007184",
        code: 1000,
        subSystem: false,
        TransferAccount : "2045800"
      },
      {
        name: "قرض الحسنه اهل بیت",
        id: "655cf16724610000bd003622",
        code: 1001,
        place: 1281,
        subSystem: true,
        TransferAccount : "111020885"
      },
      {
        name: "ثامن الائمه",
        id: "620666333b2d00005a007186",
        code: 1003,
        place: 1220,
        subSystem: true,
        TransferAccount : ""
      },
      null,
      null,
      null,
      null,
      null,
      null,
      null,
    ];

    this.Place = ["1280", "", "1280", "", "", "", "", "2811","1280", "1281"];
    this.AppName = ["قرض الخسنه انصار الحسین", "", "", "", "", "", "", "","قرض الخسنه انصار الحسین", "قرض الخسنه اهل بیت"];
    this.AppAddress = ["https://ansar724.com", "", "", "", "", "", "", "","https://ansar724.com", "https://mehr724.com"];

  }
  
  getFirebaseConfig(){
    return this.firebaseConfig[this.type];
  }

  getAppName() {
    return this.AppName[this.type];
  }
  getAppAddress() {
    return this.AppAddress[this.type];
  }

  getPlace() {
    return this.Place[this.type];
  }

  getSystem() {
    return this.type === 8 || this.type === 0 ? this.systemCode[this.system] : null;
  }

  getUrl(admin) {
    return admin
      ? this.serverUrl[this.type] + "AdminApi/"
      : this.serverUrl[this.type] + "MainApi/";
  }

  getAbsoluteUrl(getDataFromParentApi) {
    return this.serverUrl[this.type]/*getDataFromParentApi ? this.parentApiAddress[this.type] : this.serverUrl[this.type]*/;
  }

  send(url, params, SuccessCallBack, ErrorCallBack,isApi, getDataFromParentApi) {
    let serverUrl = this.serverUrl[this.type] /*getDataFromParentApi ? this.parentApiAddress[this.type] : this.serverUrl[this.type]*/;
    const myUrl = !isApi ? serverUrl + url  + "" : url;
    axios
      .post(myUrl, params)
      .then((response) => {
        SuccessCallBack(response);
      })
      .catch((error) => {
        ErrorCallBack(error);
      });
  }
  

  sendRaymand(
    url,
    params,
    SuccessCallBack,
    ErrorCallBack,
    extraParam = {}
  ) {
    const json = extraParam.json,
          method = extraParam.method,
          api = extraParam.api,
          Transfer = extraParam.Transfer,
          ip = extraParam.ip,
          port = extraParam.port;
    var m = method || "POST";
    var XMLParser = require("react-xml-parser");
    if (m == "POST") {
      if (!api) {
        var req = {
          method: "post",
          headers: {
            Accept: "application/json; charset=utf-8",
            "Content-Type": "application/json",
          },
          body: params,
        };
      } else {
        var req = {
          method: "POST",
          headers: {
            "Access-Control-Allow-Headers": "*",
            "Content-Type": "application/json",
            Authorization:
              "Bearer " +
              "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1bmlxdWVfbmFtZSI6Im5hbWUiLCJyb2xlIjoidGVsIiwibmJmIjoxNTg0NjI3MzMxLCJleHAiOjE1ODQ2MzA5MzEsImlhdCI6MTU4NDYyNzMzMX0.VL6DIeI4l1QsXzlMmn7-EmNwakjdBKa-NanP7zHlpeY",
          },
          body: params,
        };
      }
    } else {
      if (api) {
        var req = {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization:
              "Bearer " +
              "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1bmlxdWVfbmFtZSI6Im5hbWUiLCJyb2xlIjoidGVsIiwibmJmIjoxNTg0NjI3MzMxLCJleHAiOjE1ODQ2MzA5MzEsImlhdCI6MTU4NDYyNzMzMX0.VL6DIeI4l1QsXzlMmn7-EmNwakjdBKa-NanP7zHlpeY",
          },
        };
      }
    }
    if (Transfer) {
      axios
        .post(url, params, {
          headers: {
            "Access-Control-Allow-Headers": "*",
            "Content-Type": "application/json",
            Authorization:
              "Bearer " +
              "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1bmlxdWVfbmFtZSI6Im5hbWUiLCJyb2xlIjoidGVsIiwibmJmIjoxNTg0NjI3MzMxLCJleHAiOjE1ODQ2MzA5MzEsImlhdCI6MTU4NDYyNzMzMX0.VL6DIeI4l1QsXzlMmn7-EmNwakjdBKa-NanP7zHlpeY",
          },
        })
        .then(function (response) {


          
          SuccessCallBack(response.data);
        })
        .catch(function (error) {
          ErrorCallBack(error);
        });
        return;
    }
    if (!ip) {
      if (!Transfer) {
        fetch(url, req)
          .then((response) => response.json())
          .then((response) => {
            if (!api) {
              if (!json) {
                var xml = new XMLParser().parseFromString(response.d);
                SuccessCallBack(xml.children);
              } else {
                SuccessCallBack(response);
              }
            } else {
              SuccessCallBack(response);
            }
          })
          .catch((error) => {
            ErrorCallBack(error);
          });
      }
    } else {
      let serverUrl = this.serverUrl[this.type];
      req.ip = ip;
      axios
        .post(serverUrl + "MainApi/raymand_api" + "", req)
        .then((response) => {
            if(!json){
              var xml = new XMLParser().parseFromString(response.data.result.d);
              SuccessCallBack(xml.children);
            }else{
              SuccessCallBack(response.data.result);

            }
            
        })
        .catch((error) => {
          ErrorCallBack(error);
        });
    }

  }
}


export default Server;
